import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { PageHead } from "./Shop";
import { heritageData } from "../mock/content";
import useSeo from "../hooks/useSeo";

const Heritage = () => {
  const { tr, ui } = useLang();
  useSeo({
    title: ui.nav.heritage,
    description: { en: "The heritage of mosaic — the history of Antioch mosaics and the timeless art of mosaic through the ages, from Mesopotamia to the modern era.", tr: "Mozaiğin mirası — Antakya mozaiklerinin tarihi ve Mezopotamya'dan modern çağa mozaik sanatının zamansız hikâyesi." },
  });
  return (
    <div className="bg-[#f7f3ee]">
      <PageHead
        title={ui.nav.heritage}
        subtitle={tr({ en: "The timeless story of Antioch mosaics and the art of mosaic through the ages.", tr: "Antakya mozaiklerinin ve çağlar boyunca mozaik sanatının zamansız hikâyesi." })}
        image="/mosaic/2025/08/heritage1.jpg"
      />

      {heritageData.map((block, bi) => (
        <section key={bi} className={`py-20 md:py-24 ${bi % 2 === 1 ? "bg-[#efe7db]" : ""}`}>
          <div className="max-w-[1000px] mx-auto px-5 md:px-8">
            <div className="grid md:grid-cols-3 gap-10 items-start mb-12">
              <div className="md:col-span-2">
                <p className="text-[#a67c52] text-[12px] uppercase tracking-luxe mb-3">HAAS MOSAIC</p>
                <h2 className="font-serif text-4xl md:text-5xl text-[#211d18] mb-5">{tr(block.title)}</h2>
                <p className="text-[#5a5348] text-[16px] leading-relaxed">{tr(block.intro)}</p>
              </div>
              <div className="card-img-zoom overflow-hidden h-56 md:h-64">
                <img src={block.image} alt={tr(block.title)} className="w-full h-full object-cover" />
              </div>
            </div>

            <div className="space-y-9">
              {block.sections.map((s, si) => (
                <div key={si} className="border-l-2 border-[#e0d3bf] pl-6">
                  <h3 className="font-serif text-2xl text-[#211d18] mb-3">{tr(s.h)}</h3>
                  <p className="text-[#5a5348] text-[15px] leading-relaxed">{tr(s.body)}</p>
                  {s.bullets && (
                    <ul className="mt-4 grid sm:grid-cols-2 gap-2">
                      {s.bullets.map((b, i) => (
                        <li key={i} className="flex items-start gap-2.5 text-[14px] text-[#3a352d]"><Check size={15} className="text-[#a67c52] mt-0.5 shrink-0" /> {tr(b)}</li>
                      ))}
                    </ul>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      ))}

      <section className="py-16 text-center">
        <Link to="/all-projects" className="inline-flex items-center gap-3 bg-[#a67c52] hover:bg-[#8f6844] text-white text-[13px] uppercase tracking-[0.16em] px-9 py-4 transition-colors">
          {ui.viewAll} · {ui.nav.projects} <ArrowRight size={16} />
        </Link>
      </section>
    </div>
  );
};

export default Heritage;
